import { logger as LOG } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────
export const logger = LOG.extend('REFRESH API ACCESS TOKENS');
